import type { FC } from 'react';

import type { IllustrationProps } from './types';

export const DataPresentationIllustration: FC<IllustrationProps> = ({
  height = 128,
  width = 128,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M69.2585 19.4885C69.2585 17.4508 67.6066 15.7988 65.5688 15.7988C63.5311 15.7988 61.8789 17.4508 61.8789 19.4885V22.498H69.2585V19.4885Z"
      fill="#FDC221"
    />
    <path
      d="M61.8789 105.154C61.8789 107.192 63.531 108.844 65.5687 108.844C67.6064 108.844 69.2585 107.192 69.2585 105.154V93.7524H61.8789V105.154Z"
      fill="#FDC221"
    />
    <path
      d="M108.617 86.9861C108.665 86.9861 108.709 86.9983 108.757 87.0002V26.498C108.757 24.2888 106.966 22.498 104.757 22.498H24.2021C21.9929 22.498 20.2021 24.2888 20.2021 26.498V86.9861L108.617 86.9861Z"
      fill="#0D3880"
    />
    <path
      d="M108.757 87C108.709 86.9981 108.665 86.9858 108.617 86.9858H19.3833C17.5148 86.9858 16 88.5005 16 90.3691C16 92.2378 17.5148 93.7524 19.3833 93.7524H42.2163L30.208 105.761C28.7671 107.202 28.7671 109.538 30.208 110.979C31.6489 112.42 33.9852 112.42 35.4262 110.979L52.6526 93.7524H78.4845L95.7109 110.979C97.1519 112.42 99.488 112.42 100.929 110.979C102.37 109.538 102.37 107.202 100.929 105.761L88.9208 93.7524H108.617C110.485 93.7524 112 92.2378 112 90.3691C112 88.5483 110.559 87.075 108.757 87Z"
      fill="#FDC221"
    />
    <path d="M94.7051 36.1484H71.8232V39.1484H94.7051V36.1484Z" fill="white" />
    <path d="M94.7051 44.7334H71.8232V47.7334H94.7051V44.7334Z" fill="white" />
    <path d="M53.667 66.4961H30.7852V69.4961H53.667V66.4961Z" fill="white" />
    <path d="M53.667 75.082H30.7852V78.082H53.667V75.082Z" fill="white" />
    <path
      d="M51.292 36.731C48.8083 34.2472 45.3771 32.7109 41.5872 32.7109V46.4363L31.8818 56.1411C34.3656 58.6252 37.7969 60.1611 41.5872 60.1611C45.3771 60.1611 48.8083 58.6252 51.292 56.1411C53.7759 53.6577 55.3121 50.2261 55.3121 46.4363C55.3121 42.646 53.7759 39.2146 51.292 36.731Z"
      fill="#EE399E"
    />
    <path
      d="M31.8823 36.731C29.3987 39.2146 27.8623 42.646 27.8623 46.4363H41.5876V32.7109C37.7974 32.7109 34.3661 34.2472 31.8823 36.731Z"
      fill="#6E56E6"
    />
    <path
      d="M27.8623 46.436C27.8623 50.226 29.3986 53.6576 31.8823 56.141L41.5876 46.436H27.8623Z"
      fill="#56D3DF"
    />
    <path d="M79.7456 69.0957H72.709V79.2779H79.7456V69.0957Z" fill="#6E56E6" />
    <path
      d="M86.7827 60.1831H79.7461V79.2777H86.7827V60.1831Z"
      fill="#EE399E"
    />
    <path
      d="M93.8189 64.2959H86.7822V79.2779H93.8189V64.2959Z"
      fill="#28BFCE"
    />
  </svg>
);
